export default __webpack_public_path__ + "static/media/hausa.dea027ab.svg";